(function () {
  const EXTRA_OFFSET = 16;
  const RETRY_MS = 100;
  const MAX_RETRIES = 50;

  function getHeaderOffset() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    const parsed = parseFloat(raw);
    return (Number.isFinite(parsed) ? parsed : 96) + EXTRA_OFFSET;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getScrollBehavior(override) {
    if (override) return override;
    return prefersReducedMotion() ? 'auto' : 'smooth';
  }

  function getReviewsTarget(anchorId) {
    const appsSection = document.querySelector('.apps-section--product-pdp');
    if (appsSection) {
      const title = appsSection.querySelector('.jdgm-rev-widg__title');
      if (title) return title;
    }

    if (anchorId) {
      return document.getElementById(anchorId);
    }

    return null;
  }

  function scrollToReviews(anchorId, options) {
    const target = getReviewsTarget(anchorId);
    if (!target) return false;

    const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({
      top: Math.max(0, top),
      behavior: getScrollBehavior(options && options.behavior),
    });

    if (anchorId) {
      const nextHash = '#' + anchorId;
      if (history.replaceState) {
        history.replaceState(null, '', nextHash);
      } else {
        window.location.hash = nextHash;
      }
    }

    return true;
  }

  function refineScrollToTestimonials(anchorId) {
    const title = document.querySelector('.apps-section--product-pdp .jdgm-rev-widg__title');
    if (!title) return;

    const top = title.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    if (Math.abs(window.scrollY - top) > 24) {
      scrollToReviews(anchorId, { behavior: 'auto' });
    }
  }

  function scrollWithJudgeMeRetry(anchorId) {
    const behavior = getScrollBehavior();
    scrollToReviews(anchorId, { behavior });

    let tries = 0;
    const timer = window.setInterval(function () {
      tries += 1;
      const title = document.querySelector('.apps-section--product-pdp .jdgm-rev-widg__title');
      if (title) {
        refineScrollToTestimonials(anchorId);
        window.clearInterval(timer);
      } else if (tries >= MAX_RETRIES) {
        window.clearInterval(timer);
      }
    }, RETRY_MS);
  }

  function onReviewsLinkClick(event) {
    const link = event.target.closest('[data-pdp-scroll-reviews]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    const anchorId = href.slice(1);
    if (!anchorId) return;

    event.preventDefault();
    scrollWithJudgeMeRetry(anchorId);
  }

  function handleInitialHash() {
    const hash = window.location.hash;
    if (!hash || hash.indexOf('#product-reviews-') !== 0) return;

    const anchorId = hash.slice(1);
    requestAnimationFrame(function () {
      scrollWithJudgeMeRetry(anchorId);
    });
  }

  document.addEventListener('click', onReviewsLinkClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialHash);
  } else {
    handleInitialHash();
  }
})();
